import { type PropsWithChildren } from 'react'
import { Box } from '../../primitives/Box'
import { type ListItemProps } from './types'

type ListItemFooterProps = PropsWithChildren<{
  isInline?: boolean

  hasDivider?: boolean

  className?: string
}> &
  Pick<ListItemProps, 'background' | 'isSelected'>

/**
 * internal component
 */
export const ListItemFooter = ({
  children,
  className,
  isInline,
  isSelected,
  background,
  hasDivider,
}: ListItemFooterProps) => (
  <Box
    className={className}
    sx={{
      flex: '1 1 100%',
      width: 'auto',
      ...(hasDivider ? { borderTop: '1px solid', borderColor: 'divider' } : {}),
      ...(isInline
        ? { mt: 2, mx: -2, mb: -2 }
        : !isSelected && { backgroundColor: background ? 'background.default' : 'background.paper' }),
    }}
  >
    {children}
  </Box>
)
